import Admin from "@system/config/admin";
import Base from "../Base";
import Api from "../APIHandler";
const API = new Api({});

class BOMAPICall extends Base {

  getBomListByBomID = async (bomId) => {
        let res = {};
        let param = {}
        param.params = bomId
        await API.get(Admin.BOM_LIST, param).then((resHer) => {
          if (resHer.data.isSuccessFull) {
            res = resHer.data.data;
          }
        });
        return res;
    };
}

export default BOMAPICall;